import { Record } from 'immutable'

export class DocumentType extends Record({
    id: undefined,
    code: undefined,
    name: undefined,
    is_for_drivers: undefined,
    is_for_vehicles: undefined,
    is_for_trailers: undefined,
    notify: undefined,
    notify_days: undefined,
    notify_in_board: undefined,
    notify_in_board_days: undefined,
    default_validity: undefined,
}) {}
